import { GoogleAuthProvider, signInWithCredential, OAuthProvider } from 'firebase/auth';
import { ExternalAuthType, ExternalAuthTypeLabel, ExternalAuthUser } from '../models/ExternalAuthModel'
import { analyticsController } from '../../analytics/AnalyticsController';
import { Notify } from 'quasar';
import { auth, firebaseAuthentication } from '../../../../boot/firebase';
import Vue from 'vue';
import { i18n } from '../../../../boot/i18n';

interface FirebaseAuthenticationServiceState {
  needToCreateAccount: boolean,
  externalAuthUser: ExternalAuthUser | null
}

class FirebaseAuthenticationService {
  public readonly state = Vue.observable<FirebaseAuthenticationServiceState>({
    needToCreateAccount: false,
    externalAuthUser: null
  })

  reset() {
    this.state.needToCreateAccount = false
    this.state.externalAuthUser = null
  }

  async signInWhithGoogle() {
    try {
      const result = await firebaseAuthentication.signInWithGoogle({ skipNativeAuth: true });
      const credential = GoogleAuthProvider.credential(result.credential?.idToken);
      const userCredentials = await signInWithCredential(auth, credential);
      const firebaseToken = await userCredentials.user.getIdToken()

      this.state.externalAuthUser = new ExternalAuthUser(userCredentials.user, 'google', firebaseToken)
    }
    catch (error) {
      this.manageError(error, 'google')
      this.state.externalAuthUser = null
    }
  }

  async signInWithApple() {
    try {
      const result = await firebaseAuthentication.signInWithApple({ skipNativeAuth: true, mode: 'popup' });
      const provider = new OAuthProvider('apple.com')
      const credential = provider.credential({
        idToken: result.credential?.idToken,
        rawNonce: result.credential?.nonce,
        accessToken: result.credential?.accessToken
      })
      const userCredentials = await signInWithCredential(auth, credential)
      const firebaseToken = await userCredentials.user.getIdToken()
      this.state.externalAuthUser = new ExternalAuthUser(userCredentials.user, 'apple.com', firebaseToken);
    }
    catch (error) {
      this.manageError(error, 'apple.com')
      this.state.externalAuthUser = null
    }
  }

  public async logout() {
    await firebaseAuthentication.signOut()
    await auth.signOut()
  }

  private manageError(error: any, provider: ExternalAuthType) {
    if (error.code !== 'auth/cancelled-popup-request' && error.code !== 'auth/popup-closed-by-user' && error.message !== 'The user canceled the sign-in flow.') {
      analyticsController.logBasicAnalyticsEvent('firebase login failed', 'User Login', {
        provider,
        error: error.message
      })

      Notify.create({
        progress: false,
        timeout: 2000,
        multiLine: true,
        type: 'negative',
        position: 'bottom',
        message: i18n.t('firebaseAuthenticationService.errors.loginFailed', { provider: ExternalAuthTypeLabel[provider] }) as string,
      });
    }
  }
}


export const firebaseAuthenticationService = new FirebaseAuthenticationService()